import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { isBlank } from '../../utils/string'
import css from './ModalEvaluacionAlumno.module.css'

const ACTITUDES = [
  'MUY_NEGATIVA',
  'NEGATIVA',
  'NEUTRAL',
  'POSITIVA',
  'MUY_POSITIVA'
]

const Face = ({ type, isSelected, onClick }) => (
  <div
    className={css.face}
    data-selected={isSelected}
    data-type={type}
    onClick={onClick}
  >
    <i className='material-icons'>
      {type === 'MUY_POSITIVA' && 'sentiment_very_satisfied'}
      {type === 'POSITIVA' && 'sentiment_satisfied'}
      {type === 'NEUTRAL' && 'sentiment_neutral'}
      {type === 'NEGATIVA' && 'sentiment_dissatisfied'}
      {type === 'MUY_NEGATIVA' && 'sentiment_very_dissatisfied'}
    </i>
  </div>
)

const ModalEvaluacionAlumno = ({
  open,
  alumno = '',
  asignaturas = [],
  onSubmit,
  onClose,
  disabled = false,
  submitLabel = 'Aceptar'
}) => {
  const [form, setForm] = useState({
    actitud: '',
    limpieza: '',
    asignaturas: {},
    observaciones: ''
  })

  useEffect(() => {
    if (open) {
      setForm({
        actitud: '',
        limpieza: '',
        asignaturas: {},
        observaciones: ''
      })
    }
  }, [open, alumno])

  const handleEvaluacionActitudChange = type => {
    setForm(prev => ({ ...prev, actitud: type }))
  }

  const handleEvaluacionLimpiezaChange = type => {
    setForm(prev => ({ ...prev, limpieza: type }))
  }

  const handleEvaluacionAsignaturaChange = (asignatura, type) => {
    setForm(prev => ({
      ...prev,
      asignaturas: { ...prev.asignaturas, [asignatura]: type }
    }))
  }

  const handleSubmit = () => {
    onSubmit({
      actitud: form.actitud,
      limpieza: form.limpieza,
      asignaturas: form.asignaturas,
      observaciones: form.observaciones
    })
  }

  const isSubmitDisabled =
    isBlank(form.actitud) ||
    isBlank(form.limpieza) ||
    asignaturas.some(item => isBlank(form.asignaturas[item.asignatura.id]))

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Evaluación de {alumno?.nombre}</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.section}>
          <DialogContentText className={css.sectionTitle}>
            Actitud
          </DialogContentText>
          <div className={css.faces}>
            {ACTITUDES.map(type => (
              <Face
                key={`actitud-${type}`}
                type={type}
                isSelected={type === form.actitud}
                onClick={() => handleEvaluacionActitudChange(type)}
              />
            ))}
          </div>
        </div>
        <div className={css.section}>
          <DialogContentText className={css.sectionTitle}>
            Limpieza
          </DialogContentText>
          <div className={css.faces}>
            {ACTITUDES.map(type => (
              <Face
                key={`limpieza-${type}`}
                type={type}
                isSelected={type === form.limpieza}
                onClick={() => handleEvaluacionLimpiezaChange(type)}
              />
            ))}
          </div>
        </div>
        {asignaturas.map(item => (
          <div key={item.asignatura.id}>
            <div className={css.section}>
              <DialogContentText className={css.sectionTitle}>
                Eficacia ({item.asignatura.nombre})
              </DialogContentText>
              <div className={css.faces}>
                {ACTITUDES.map(type => (
                  <Face
                    key={`${item.asignatura.id}-${type}`}
                    type={type}
                    isSelected={type === form.asignaturas[item.asignatura.id]}
                    onClick={() =>
                      handleEvaluacionAsignaturaChange(item.asignatura.id, type)
                    }
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
        <div className={css.section}>
          <TextField
            label='Observaciones'
            placeholder='Escribe cualquier observación (opcional)'
            multiline
            rows={4}
            variant='standard'
            fullWidth
            value={form.observaciones}
            onChange={e =>
              setForm(prev => ({ ...prev, observaciones: e.target.value }))
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || disabled}
          color='primary'
          onClick={handleSubmit}
        >
          {submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEvaluacionAlumno
